import { useState } from 'react'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { ImageIcon } from 'lucide-react'

interface ImageUrlInputProps {
  label: string
  value: string
  onChange: (url: string) => void
  description?: string
}

export function ImageUrlInput({ label, value, onChange, description }: ImageUrlInputProps) {
  const [imageError, setImageError] = useState(false)

  return (
    <div className="space-y-2">
      <Label htmlFor={label.toLowerCase().replace(/\s+/g, '-')}>{label}</Label>
      <div className="flex gap-2">
        <Input
          type="url"
          id={label.toLowerCase().replace(/\s+/g, '-')}
          value={value}
          onChange={(e) => {
            onChange(e.target.value)
            setImageError(false)
          }}
          placeholder="https://example.com/image.png"
          className="flex-1"
        />
        {value && !imageError ? (
          <img
            src={value}
            alt={label}
            className="w-10 h-10 rounded object-cover border border-border"
            onError={() => setImageError(true)}
          />
        ) : (
          <div className="w-10 h-10 rounded border border-border flex items-center justify-center bg-muted">
            <ImageIcon className="h-5 w-5 text-muted-foreground" />
          </div>
        )}
      </div>
      {description && (
        <p className="text-xs text-muted-foreground">{description}</p>
      )}
    </div>
  )
}
